"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutReducerWithSearchPopup = void 0;
var LayoutReducer_1 = require("@/pages/common/reducers/LayoutReducer");
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
var MegaMenuSearchPopupReducer_1 = require("@/pages/common/reducers/MegaMenuSearchPopupReducer");
exports.layoutReducerWithSearchPopup = function (state, action) {
    if (state === void 0) { state = LayoutState_init_1.defaultLayoutState; }
    var newState = LayoutReducer_1.layoutReducer(state, action);
    return MegaMenuSearchPopupReducer_1.megaMenuSearchPopupReducer(newState, action);
};
